export enum TreemapKeyCommand {
  ZoomIn = 'zoomIn',
  ZoomOut = 'zoomOut',
  AscendDrill = 'ascendDrill',
  FocusParent = 'focusParent',
  FocusFirstChild = 'focusFirstChild',
  FocusPreviousSibling = 'focusPreviousSibling',
  FocusNextSibling = 'focusNextSibling',
  DrillIntoHovered = 'drillIntoHovered',
}

interface RunTreemapKeyCommandInput {
  command: TreemapKeyCommand;
  hoveredNodeId: string | null;
  zoomIn: () => void;
  zoomOut: () => void;
  ascendDrill: () => void;
  focusParent: () => void;
  focusFirstChild: () => void;
  focusPreviousSibling: () => void;
  focusNextSibling: () => void;
  drillIntoNode: (nodeId: string) => void;
}

type TreemapKeyCommandHandler = (input: RunTreemapKeyCommandInput) => void;

const TREEMAP_KEY_COMMAND_BY_KEY = new Map<string, TreemapKeyCommand>([
  ['+', TreemapKeyCommand.ZoomIn],
  ['=', TreemapKeyCommand.ZoomIn],
  ['-', TreemapKeyCommand.ZoomOut],
  ['_', TreemapKeyCommand.ZoomOut],
  ['Escape', TreemapKeyCommand.AscendDrill],
  ['ArrowUp', TreemapKeyCommand.FocusParent],
  ['ArrowDown', TreemapKeyCommand.FocusFirstChild],
  ['ArrowLeft', TreemapKeyCommand.FocusPreviousSibling],
  ['ArrowRight', TreemapKeyCommand.FocusNextSibling],
  ['Enter', TreemapKeyCommand.DrillIntoHovered],
  [' ', TreemapKeyCommand.DrillIntoHovered],
]);

const TREEMAP_KEY_COMMAND_HANDLERS: Record<TreemapKeyCommand, TreemapKeyCommandHandler> = {
  [TreemapKeyCommand.ZoomIn]: (input) => input.zoomIn(),
  [TreemapKeyCommand.ZoomOut]: (input) => input.zoomOut(),
  [TreemapKeyCommand.AscendDrill]: (input) => input.ascendDrill(),
  [TreemapKeyCommand.FocusParent]: (input) => input.focusParent(),
  [TreemapKeyCommand.FocusFirstChild]: (input) => input.focusFirstChild(),
  [TreemapKeyCommand.FocusPreviousSibling]: (input) => input.focusPreviousSibling(),
  [TreemapKeyCommand.FocusNextSibling]: (input) => input.focusNextSibling(),
  [TreemapKeyCommand.DrillIntoHovered]: (input) => {
    if (!input.hoveredNodeId) {
      return;
    }

    input.drillIntoNode(input.hoveredNodeId);
  },
};

export function getTreemapKeyCommand(key: string): TreemapKeyCommand | null {
  return TREEMAP_KEY_COMMAND_BY_KEY.get(key) ?? null;
}

export function runTreemapKeyCommand(input: RunTreemapKeyCommandInput): void {
  TREEMAP_KEY_COMMAND_HANDLERS[input.command](input);
}
